import * as React from "react";
import { DatosEnvioMora } from "../modelo/EnvioReporteMora";
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import { FormGroup, FormControl } from "react-bootstrap";
import { obtenerCodigoEnvio } from "../modelo/TipoReporte";

export class ModalConfirmarEnvioMora extends React.Component<ModalConfirmarEnvioMoraProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: true,
            observacion: ''
        };
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleClose() {
        this.setState({ show: false });
        this.props.cerrarModal();
    }

    render() {
        return (
            <div>
                {this.renderModalGestion()}
            </div>
        );
    }

    renderModalGestion() {
        const { datosEnvio } = this.props;
        const btnAcciones = [
            (
                <FlatButton key={1}
                    label={"Enviar"}
                    disabled={!this.state.observacion}
                    onClick={() => {
                        this.handleClose();
                        datosEnvio.justificacion = this.state.observacion;
                        this.props.procesarEnvio(datosEnvio);
                    }}
                />
            ), (
                <FlatButton key={0}
                    label="Cancelar"
                    onClick={() => this.handleClose()} />
            )
        ];
        return (
            <div>
                <Dialog title={"Confirmar envio Individual de Mora"}
                    actions={btnAcciones}
                    contentStyle={{ width: '40%', maxWidth: 'none' }}
                    open={this.state.show}
                    onRequestClose={() => this.handleClose()}
                    modal={false}>
                    {this.renderContenidoGestion()}
                </Dialog>
            </div>
        );
    }

    renderContenidoGestion() {
        const { datosEnvio } = this.props;
        const nombreReporte = obtenerCodigoEnvio(datosEnvio.tipoReporte).nombreReporte.toLowerCase();
        console.log(nombreReporte);
        return (
            <div>
                <div className="modal-form-text info-col" style={{ marginBottom: '25px' }}>
                    <span>Se enviara a SAT a <strong>{nombreReporte}</strong> el periodo <strong>{datosEnvio.periodo}</strong> para la poliza <strong>{datosEnvio.poliza}</strong></span>
                    <br />
                    <Divider />
                    <br />
                    <span>Se debe registrar una observacion del motivo de reporte:</span>
                </div>
                <div>
                    <FormGroup controlId="formControlsTextarea" validationState={this.getValidationState()}>
                        <FormControl
                            value={this.state.observacion}
                            onChange={e => this.setState({ observacion: e.target.value })}
                            componentClass="textarea"
                            placeholder="Observación"
                            style={{ height: 130 }} maxLength={256}
                        />
                    </FormGroup>
                </div>
            </div>
        );
    }

    getValidationState() {
        const length = this.state.observacion.length;
        if (length > 0) return 'success';
        if (length === 0) return 'error';
        return null;
    }

}
interface ModalConfirmarEnvioMoraProps {
    datosEnvio: DatosEnvioMora,
    cerrarModal: () => void,
    procesarEnvio: (datosEnvio: DatosEnvioMora) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_mora/componentes/ModalConfirmarEnvioMora.tsx